import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

//token not working
const login = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.LOGIN.LOGIN, data);
};

export default login;
